import AppIcon from '../../../components/AppIcon';

const EmailPreviewPanel = ({ template, deviceMode, emailClient }) => {
  const getDeviceWidth = () => {
    switch (deviceMode) {
      case 'mobile':
        return 'max-w-sm';
      case 'tablet':
        return 'max-w-2xl';
      default:
        return 'w-full';
    }
  };

  const getClientStyles = () => {
    switch (emailClient) {
      case 'outlook':
        return 'bg-blue-50';
      case 'apple-mail':
        return 'bg-gray-50';
      default:
        return 'bg-white';
    }
  };

  return (
    <div className="bg-card rounded-lg border border-border overflow-hidden">
      {/* Panel Header */}
      <div className="bg-muted px-6 py-4 border-b border-border">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <AppIcon name="Eye" size={20} className="text-primary" />
            <h3 className="font-semibold text-foreground">معاينة الإيميل</h3>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-xs text-muted-foreground">عرض {deviceMode === 'desktop' ? 'سطح المكتب' : deviceMode === 'tablet' ? 'التابلت' : 'الموبايل'}</span>
            <div className={`w-2 h-2 rounded-full ${
              emailClient === 'gmail' ? 'bg-red-500' :
              emailClient === 'outlook'? 'bg-blue-500' : 'bg-gray-500'
            }`} />
          </div>
        </div>
      </div>
      {/* Email Preview Container */}
      <div className="p-6 bg-muted/30 min-h-[600px] flex items-start justify-center">
        <div className={`${getDeviceWidth()} transition-all duration-300`}>
          {/* Email Client Interface */}
          <div className={`${getClientStyles()} rounded-lg shadow-lg overflow-hidden border border-border`}>
            {/* Email Header */}
            <div className="bg-white border-b border-gray-200 p-4">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary flex items-center justify-center">
                  <AppIcon name="Mail" size={20} className="text-white" />
                </div>
                <div className="flex-1">
                  <p className="font-semibold text-sm text-gray-900">مشهد</p>
                  <p className="text-xs text-gray-500">noreply@photographybooking.sa</p>
                </div>
                <span className="text-xs text-gray-400">الآن</span>
              </div>
              <h2 className="text-lg font-bold text-gray-900 text-right" dir="rtl">
                {template?.subject}
              </h2>
            </div>

            {/* Email Body */}
            <div className="p-6 bg-white" dir="rtl">
              <div className="prose prose-sm max-w-none">
                <div className="whitespace-pre-wrap text-right font-['IBM_Plex_Sans_Arabic'] text-gray-800 leading-relaxed">
                  {template?.body}
                </div>
              </div>

              {/* Email Footer */}
              <div className="mt-8 pt-6 border-t border-gray-200">
                <div className="text-center space-y-2">
                  <div className="flex items-center justify-center gap-4">
                    <a href="#" className="text-primary hover:underline text-sm">زيارة الموقع</a>
                    <span className="text-gray-300">|</span>
                    <a href="#" className="text-primary hover:underline text-sm">تواصل معنا</a>
                    <span className="text-gray-300">|</span>
                    <a href="#" className="text-primary hover:underline text-sm">إلغاء الاشتراك</a>
                  </div>
                  <p className="text-xs text-gray-500">
                    © 2026 مشهد. جميع الحقوق محفوظة.
                  </p>
                  <p className="text-xs text-gray-400">
                    هذا البريد الإلكتروني تم إرساله من نظام آلي. يرجى عدم الرد على هذا البريد.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Variable Indicators */}
          <div className="mt-4 bg-blue-50 border border-blue-200 rounded-lg p-4">
            <div className="flex items-start gap-2">
              <AppIcon name="Info" size={16} className="text-blue-600 mt-0.5" />
              <div className="flex-1">
                <p className="text-xs font-semibold text-blue-900 mb-2">المتغيرات المستخدمة:</p>
                <div className="flex flex-wrap gap-2">
                  {Object.entries(template?.variables || {})?.map(([key, value]) => (
                    <span key={key} className="inline-flex items-center gap-1 px-2 py-1 bg-white border border-blue-300 rounded text-xs">
                      <code className="text-blue-700">{`{{${key}}}`}</code>
                      <span className="text-gray-400">→</span>
                      <span className="text-gray-700">{value}</span>
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailPreviewPanel;